<template>
  <div class="column_center_start">
    <storeBanner :store="storeName" :showVipCard="false" />
    <storeInfoDetail></storeInfoDetail>
    <button class="button" style="width: 92vw; margin: 30px 0; flex-shrink: 0" v-if="!isStoreMember"
      @click="isLogin ? joinMember() : login()">
      加入店家VIP
    </button>
    <button class="button" style="width: 92vw; margin: 30px 0; flex-shrink: 0" v-else @click="toMemberPage">
      VIP會員卡
    </button>
    <!-- <div class="column_start_start" style="width: 92vw">
      <p style="
          color: #666666;
          font-size: 16px;
          font-weight: 600;
          font-family: PingFang Screen;
        ">
        會員見面禮
      </p>
    </div> -->
  </div>
</template>

<script>
import storeBanner from '../components/store/storeBanner.vue';
import storeInfoDetail from "../components/store/storeInfoDetail.vue";
import commonUtils from "@/utils/common.utils";
import apiData from "@/services/apiData";
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  components: {
    storeInfoDetail: storeInfoDetail,
    storeBanner: storeBanner
  },
  computed: {
    ...mapGetters('basic', {
      storeName: 'storeName',
    }),
    ...mapGetters('userData', {
      isLogin: 'isLogin',
      isStoreMember: 'isStoreMember',
      storeMemberUuid: 'storeMemberUuid',
      storeCode: 'storeCode'
    }),
    ...mapState('userData', {
      storeData: 'storeData'
    }),
    currentStore() {
      return this.$store.state.basic.currentStore
    }
  },
  watch: {
    isLogin(state) {
      if (state && !this.isStoreMember) {
        this.joinMember()
      } else if (state && this.isStoreMember && this.storeMemberUuid) {
        this.toMemberPage()
      }
    }
  },
  methods: {
    toMemberPage() {
      this.$router.push({
        path: `/${this.currentStore}`,
      });
    },
    async joinMember() {
      try {
        commonUtils.createLoading("資料讀取中", "請稍後");
        await this.$store.dispatch('userData/joinMember')
        commonUtils.closeLoading()
        commonUtils.delay(500)
        commonUtils.createToast("success", "加入成功")
      } catch (e) {
        console.log('join member error', e)
        commonUtils.closeLoading()
        commonUtils.delay(500)
        commonUtils.createToast("error", `${e}`)
      }
    },
    login() {
      let data = new apiData();
      data.store = this.storeCode;
      this.$store.dispatch('line/login', data)
    },
  },
};
</script>

<style lang="scss"></style>
